import { useState, useEffect, forwardRef } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Paper, TableBody, makeStyles, TableCell, TableRow, Switch, Modal
  , IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as yup from 'yup';
import { useFormik } from 'formik';
import './ChallengesAdmin.css'
import Cookies from 'universal-cookie';
import { Edit, Cancel } from '@mui/icons-material';
import AdminTable from '../Components/AdminTable';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from 'react-router';
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const estado = [
  {
    value: '',
    label: ''
  },
  {
    value: 'visible',
    label: 'Visible'
  },

  {
    value: 'oculto',
    label: 'Oculto'
  },

];
const points = [
  {
    value: '',
    label: ''
  },
  {
    value: 50,
    label: '50'
  },
  {
    value: 100,
    label: '100'
  },
  {
    value: 150,
    label: '150'
  },
  {
    value: 200,
    label: '200'
  },
  {
    value: 250,
    label: '250'
  },
  {
    value: 300,
    label: '300'
  },
  {
    value: 350,
    label: '350'
  },
  {
    value: 400,
    label: '400'
  },
  {
    value: 450,
    label: '450'
  },
  {
    value: 500,
    label: '500'
  }
];
const pointsHint = [
  {
    value: '',
    label: ''
  },
  {
    value: '0',
    label: '0'
  },
  {
    value: 10,
    label: '10'
  },
  {
    value: 15,
    label: '15'
  },
  {
    value: 30,
    label: '30'
  },
  {
    value: 50,
    label: '50'
  },
  {
    value: 100,
    label: '100'
  },
  {
    value: 150,
    label: '150'
  },
];
const categoryS = [
  {
    label: '',
    value: ''
  },
  {
    value: 1,
    label: 'Esteganografía'
  },
  {
    value: 2,
    label: 'Criptografía'
  },
  {
    value: 3,
    label: 'OSINT'
  },
  {
    value: 4,
    label: 'Pwn'
  },
  {
    value: 5,
    label: 'Explotación Web'
  },
  {
    value: 6,
    label: 'Fundamentos'
  },
  {
    value: 7,
    label: 'Ingeniería Inversa'
  },
  {
    value: 8,
    label: 'Programación'
  },
  {
    value: 9,
    label: 'Seguridad Móvil'
  },
  {
    value: 10,
    label: 'Misceláneo'
  },
  {
    value: 11,
    label: 'Análisis Forense'
  },

  {
    value: 12,
    label: 'Trivia'
  }
];
const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'absolute',
    width: 400,
    backgroundColor: 'white',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    //padding: '16px 32px 24px',
    padding: theme.spacing(2, 4, 3, 4),
    transform: 'translate(-40%, -40%)',
  },
  paperContentTable: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    overflowX: 'auto',
  },
  searchInput: {
    width: '75%'
  },
  nameHead: {
    maxWidth: 200,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

  },

  buttonModified: {
    margin: theme.spacing(1),
  }

}))


const ChallengesAdmin = () => {
  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const history = useHistory();
  const classes = useStyles();
  const [records, setRecords] = useState([])
  const [recordsHint, setRecordsHint] = useState([])
  const [modalAdChall, setModalAdChall] = useState(false);
  const [modalAdChallEdit, setModalAdChallEdit] = useState(false);
  const [modalAdHint, setModalAdHint] = useState(false);
  const [modalAdHintEdit, setModalAdHintEdit] = useState(false);
  const [challengeIdEdit, setChallengeIdEdit] = useState(0);
  const [nameEdit, setNameEdit] = useState('');
  const [descriptionEdit, setDescriptionEdit] = useState('');
  const [linkEdit, setLinkEdit] = useState('');
  const [valueEdit, setValueEdit] = useState(0);
  const [categoryEdit, setCategoryEdit] = useState(0);
  const [flagEdit, setFlagEdit] = useState('');
  const [hint, setHint] = useState('');
  const [cost, setCost] = useState(0);
  const [hintChallID, setHintChallID] = useState(0);
  const [hintEdit, setHintEdit] = useState('');
  const [costEdit, setCostEdit] = useState(0);
  const [hintIDEdit, setHintIDEdit] = useState(0);
  const [challengesList, setChallengesList] = useState([]);
  const [changeTable, setChangeTable] = useState(false);
  const [changeTableHint, setChangeTableHint] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openRemoveDialogHint, setOpenRemoveDialogHint] = useState(false);
  const [removeChallengeID, setRemoveChallengeID] = useState(0);
  const [removeHintID, setRemoveHintID] = useState(0);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenError(false);
    setOpenSuccess(false);
  };
  function handleOpenRemoveDialog(id) {
    setOpenRemoveDialog(true);
    setRemoveChallengeID(id);
  };
  function handleOpenRemoveDialogHint(id) {
    setOpenRemoveDialogHint(true);
    setRemoveHintID(id);
  };

  const handleCloseRemoveDialog = () => {
    setOpenRemoveDialog(false);
    setRemoveChallengeID(0);
  };
  const handleCloseRemoveDialogHint = () => {
    setOpenRemoveDialogHint(false);
    setRemoveHintID(0);
  };
  //TABLE
  const headCells = [
    { id: 'name', label: 'Nombre' },
    { id: 'category', label: 'Categoría' },
    { id: 'value', label: 'Valor' },
    { id: 'status', label: 'Estado' },
    { id: 'actions', label: 'Acciones' },
  ]
  const headCellsHint = [
    { id: 'name', label: 'Reto' },
    { id: 'hint', label: 'Pista' },
    { id: 'value', label: 'Costo' },
    { id: 'actions', label: 'Acciones' },
  ]
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = AdminTable(records, headCells);
  const {
    TblContainer: TblContainerHint,
    TblHead: TblHeadHint,
    TblPagination: TblPaginationHint,
    recordsAfterPagingAndSorting: recordsAfterPagingAndSortingHint
  } = AdminTable(recordsHint, headCellsHint);


  //TABLE
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/getChallenges`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecords(response.data);
      }
    })
    setChangeTable(false)

  }, [changeTable])
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/getHints`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecordsHint(response.data);
      }
    })
    setChangeTableHint(false);

  }, [changeTableHint])



  const formikAd = useFormik({
    initialValues: {
      name: '',
      description: '',
      link: '',
      value: 0,
      category_id: 0,
      state: '',
      flag: '',
    },
    validationSchema: yup.object({
      name: yup.string()
        .required('Campo requerido *'),
      description: yup.string()
        .required('Campo requerido *'),
      value: yup.number('Valor debe ser un número entero')
        .required('Campo requerido *'),
      category: yup.number().required('Campo requerido *'),
      link: yup.string(),
      state: yup.string().required('Campo requerido *'),
      flag: yup.string().required('Campo requerido *'),

    }),
    onSubmit: values => {
      axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/createChallenge`, {
        name: values.name,
        description: values.description,
        link: values.link,
        value: values.value,
        category_id: values.category,
        state: values.state,
        flag: values.flag,

      }, {
        headers: { 'Authorization': userToken }
      }).then((response) => {
        if (response.data.noAuth) {
          cookies.remove('tokenCTF', { path: '/' });
          history.push('/login');
        }
        else {
          if (response.data.messageSuccess) {
            setChangeTable(true);
            setModalAdChall(false);
            setSuccessMessage(response.data.messageSuccess)
            setOpenSuccess(true)
            formikAd.handleReset();
          }
          else if (response.data.messageError) {
            setErrorMessage(response.data.messageError)
            setOpenError(true)
          }
          else {
            setErrorMessage('');
            setOpenError(false);
            setSuccessMessage('');
            setOpenSuccess(false);
          }
        }
      });


    }
  });

  const changeSwitch = (e, value, id) => {
    const state = value ? 'visible' : 'oculto';
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/updateChallengeState`, {
      challenge_id: id,
      state: state
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
    });

  }
  const updateChallenge = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/updateChallenge`, {
      challenge_id: challengeIdEdit,
      name: nameEdit,
      description: descriptionEdit,
      link: linkEdit,
      value: valueEdit,
      category: categoryEdit,
      flag: flagEdit,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setChangeTable(true);
          setModalAdChallEdit(false);
          setSuccessMessage(response.data.messageSuccess)
          setOpenSuccess(true)
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    })
  }
  const deleteChallenge = (challenge_id) => {
    axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/challengeDelete/${challenge_id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setChangeTable(true);
          setOpenRemoveDialog(false);
          setSuccessMessage(response.data.messageSuccess)
          setOpenSuccess(true)
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }

    })
  }
  const deleteHint = (hint_id) => {
    axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/hintDelete/${hint_id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setChangeTableHint(true);
          setOpenRemoveDialogHint(false);
          setSuccessMessage(response.data.messageSuccess)
          setOpenSuccess(true)
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }

    })
  }
  //MODAL

  const openCloseModal = () => {
    setModalAdChall(!modalAdChall);
  }
  const closeModalHint = () => {
    setHint('');
    setHintChallID(0);
    setCost(0);
    setModalAdHint(false);
  }
  const closeModalHintEdit = () => {
    setHintEdit('');
    setHintIDEdit(0);
    setCostEdit(0);
    setModalAdHintEdit(false);
  }
  const openModalHint = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/getChallengeName`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setChallengesList(response.data);
        setModalAdHint(true);
      }
    });
  }

  const closeModalEdit = () => {
    setModalAdChallEdit(false);
    setNameEdit('')
    setDescriptionEdit('')
    setLinkEdit('')
    setValueEdit(0)
    setCategoryEdit(0)
    setFlagEdit('')
    setChallengeIdEdit('')
    setPasswordShownEdit(false)
  }
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownEdit, setPasswordShownEdit] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const togglePasswordEdit = () => {
    setPasswordShownEdit(!passwordShownEdit);
  };
  const closeModalAdd = () => {
    setModalAdChall(false);
    setPasswordShown(false)
    formikAd.handleReset();
  }
  const onSubmitHint = () => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/createHint`, {
      challenge_id: hintChallID,
      hint: hint,
      cost: cost
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setModalAdHint(false);
          setSuccessMessage(response.data.messageSuccess)
          setOpenSuccess(true)
          setHint('');
          setCost(0);
          setHintChallID(0);
          setChangeTableHint(true);
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    });
  }
  const onUpdateHint = () => {
    axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/updateHint`, {
      hint_id: hintIDEdit,
      hint: hintEdit,
      cost: costEdit
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setModalAdHintEdit(false);
          setSuccessMessage(response.data.messageSuccess)
          setOpenSuccess(true)
          setHintEdit('');
          setCostEdit(0);
          setHintEdit(0);
          setChangeTableHint(true);
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    });

  }
  return (


    <>
      <Modal open={modalAdChall} onClose={openCloseModal} className="modalMarginBottom20">
        <form
          onSubmit={formikAd.handleSubmit}
          autoComplete="off"
        >
          <Card className="cardMarginWidth">
            <CardHeader
              title="Creación de Retos"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={4}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  {formikAd.touched.name && formikAd.errors.name ? <span className="spanColorFontsize">{formikAd.errors.name}</span> : null}
                  <TextField
                    fullWidth
                    label="Titulo"
                    name="name"
                    required
                    variant="outlined"
                    {...formikAd.getFieldProps("name")}
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  {formikAd.touched.description && formikAd.errors.description ? <span className="spanColorFontsize">{formikAd.errors.description}</span> : null}
                  <TextField
                    fullWidth
                    multiline
                    label="Descripción"
                    name="Description"
                    required
                    variant="outlined"
                    {...formikAd.getFieldProps("description")}
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  {formikAd.touched.value && formikAd.errors.value ? <span className="spanColorFontsize">{formikAd.errors.value}</span> : null}
                  <TextField
                    fullWidth
                    label="Valor"
                    name="value"
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    {...formikAd.getFieldProps("value")}
                  >
                    {points.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  {formikAd.touched.category && formikAd.errors.category ? <span className="spanColorFontsize">{formikAd.errors.category}</span> : null}

                  <TextField
                    fullWidth
                    label="Categoría"
                    name="category"
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    {...formikAd.getFieldProps("category")}
                  >
                    {categoryS.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>

                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  {formikAd.touched.state && formikAd.errors.state ? <span className="spanColorFontsize">{formikAd.errors.state}</span> : null}

                  <TextField
                    fullWidth
                    label="Estado"
                    name="state"
                    required
                    select
                    SelectProps={{ native: true }}

                    variant="outlined"
                    {...formikAd.getFieldProps("state")}
                  >
                    {estado.map((option) => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>

                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <div className="displayFlexAlignCenter">
                    {formikAd.touched.flag && formikAd.errors.flag ? <span className="spanColorFontsize">{formikAd.errors.flag}</span> : null}
                    <TextField
                      fullWidth
                      label="Flag"
                      name="Flag"
                      required
                      type={passwordShown ? "text" : "password"}
                      variant="outlined"
                      {...formikAd.getFieldProps("flag")}
                    />
                    <VisibilityIcon onClick={togglePassword} className="iconMarginCursor" />
                  </div>
                </Grid>


                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Link (Opcional - ejemplo: https://www.google.com)"
                    name="Link"
                    variant="outlined"
                    {...formikAd.getFieldProps("link")}
                  />

                </Grid>


              </Grid>
            </CardContent>
            <Divider />
            <Divider />
            <Box
            className="boxDisplayJusfify"
            >
              <Button type='submit' color="primary" variant="outlined" className="buttonModified"
              >
                Enviar
              </Button>
              <Button color="secondary" variant="outlined" className="buttonModified" onClick={closeModalAdd}>
                Cancelar
              </Button>

            </Box>
          </Card>
        </form>
      </Modal>
      {/*!---MODAL EDIT--*/}
      <Modal open={modalAdChallEdit} onClose={closeModalEdit} >
        <Card className="cardMarginWidth2">
          <CardHeader
            title="Modificar reto"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={4}
            >
              <Grid
                item
                md={6}
                xs={12}
              >


                <TextField
                  fullWidth
                  label="Titulo"
                  name="name"
                  variant="outlined"
                  defaultValue={nameEdit}
                  onChange={(e) => {
                    setNameEdit(e.target.value)
                  }}
                />

              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Descripcion"
                  name="Description"
                  required
                  variant="outlined"
                  defaultValue={descriptionEdit}

                  onChange={(e) => {
                    setDescriptionEdit(e.target.value)
                  }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Link"
                  name="Link"
                  required
                  variant="outlined"
                  defaultValue={linkEdit}
                  onChange={(e) => {
                    setLinkEdit(e.target.value)
                  }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Valor"
                  name="value"
                  required
                  variant="outlined"
                  select
                  defaultValue={valueEdit}
                  SelectProps={{ native: true }}
                  onChange={(e) => {
                    setValueEdit(e.target.value)
                  }}
                >
                  {points.map((option, index) => (
                    <option
                      key={index}
                      defaultValue={valueEdit}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>

              <Grid
                item
                md={6}
                xs={12}
              >

                <TextField
                  fullWidth
                  label="Categoria"
                  name="category"
                  select
                  defaultValue={categoryEdit}
                  SelectProps={{ native: true }}
                  variant="outlined"
                  onChange={(e) => {
                    setCategoryEdit(e.target.value)
                  }}
                >
                  {categoryS.map((option, index) => (
                    <option
                      key={index}
                      defaultValue={categoryEdit}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <div className="displayFlexAlignCenter">
                  <TextField
                    fullWidth
                    label="Flag"
                    name="Flag"
                    type={passwordShownEdit ? "text" : "password"}
                    required
                    variant="outlined"
                    defaultValue={flagEdit}
                    onChange={(e) => {
                      setFlagEdit(e.target.value)

                    }}
                  />
                  <VisibilityIcon onClick={togglePasswordEdit} className="iconMarginCursor" />
                </div>
              </Grid>

            </Grid>
          </CardContent>
          <Divider />
          <Box
          className="boxDisplayJusfify"
          >
            <Button type='submit'
              onClick={(e) => { updateChallenge() }} variant='outlined' color="primary" className="buttonModified">
              Actualizar
            </Button>
            <Button type='submit'
              onClick={(e) => { closeModalEdit() }} variant='outlined' color="secondary" className="buttonModified">
              Cancelar
            </Button>
          </Box>
        </Card>
      </Modal>
      <Modal open={modalAdHint} onClose={closeModalHint}>

        <Card className="cardMarginWidth3">
          <CardHeader
            title="Creación de Pistas"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={4}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Pista"
                  name="hint"
                  required
                  variant="outlined"
                  onChange={(e) => { setHint(e.target.value) }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Costo"
                  name="cost"
                  required
                  select
                  SelectProps={{ native: true }}
                  variant="outlined"
                  onChange={(e) => { setCost(e.target.value) }}
                >
                  {pointsHint.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Reto"
                  name="value"
                  required
                  variant="outlined"
                  select
                  SelectProps={{ native: true }}
                  onChange={(e) => {
                    setHintChallID(e.target.value)
                  }}
                >
                  {challengesList.map((option, index) => (
                    <option
                      key={index}
                      value={option.challenge_id}
                    >
                      {option.name}
                    </option>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <Divider />
          <Box
          className="boxDisplayJusfify"
          >
            <Button type='submit' color="primary" variant="outlined" className="buttonModified"
              onClick={(e) => { onSubmitHint() }}>
              Enviar
            </Button>
            <Button color="secondary" variant="outlined" className="buttonModified" onClick={closeModalHint}>
              Cancelar
            </Button>

          </Box>
        </Card>
      </Modal>
      <Modal open={modalAdHintEdit} onClose={closeModalHintEdit}>

        <Card className="cardMarginWidth3">
          <CardHeader
            title="Editar Pista"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={4}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Pista"
                  name="hint"
                  required
                  defaultValue={hintEdit}
                  variant="outlined"
                  onChange={(e) => { setHintEdit(e.target.value) }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Costo"
                  name="cost"
                  required
                  defaultValue={costEdit}
                  select
                  SelectProps={{ native: true }}
                  variant="outlined"
                  onChange={(e) => { setCostEdit(e.target.value) }}
                >
                  {pointsHint.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>

            </Grid>
          </CardContent>
          <Divider />
          <Divider />
          <Box
            className="boxDisplayJusfify"
          >
            <Button type='submit' color="primary" variant="outlined" className="buttonModified"
              onClick={(e) => { onUpdateHint() }}>
              Enviar
            </Button>
            <Button color="secondary" variant="outlined" className="buttonModified" onClick={closeModalHintEdit}>
              Cancelar
            </Button>

          </Box>
        </Card>
      </Modal>

      <div className="pageContentAdmin">

        <div className="pageContentTableAdmin">
          <Paper className="paperContentTable">
            <div align="right">
              <Button variant="outlined" color="primary" onClick={() => openCloseModal()}  >Nuevo reto</Button>
            </div>
            <TblContainer>
              <TblHead className="cell" />
              <TableBody>
                {
                  recordsAfterPagingAndSorting().map((item) => (

                    <TableRow key={item.challenge_id} >
                      <TableCell className="nameHead"> {item.name}</TableCell>
                      <TableCell >{item.title}</TableCell>
                      <TableCell >{item.value}</TableCell>
                      <TableCell ><div className="status-challenge"><h5>Oculto</h5><Switch color="primary" defaultChecked={item.state === 'visible' ? true : false}
                        onClick={(e) => {
                          changeSwitch(e, e.target.checked, item.challenge_id)
                        }} /><h5>Visible</h5></div></TableCell>
                      <TableCell>
                        <div className="actions-admin">
                          <IconButton onClick={() => axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/getChallenge/${item.challenge_id}`, {
                            headers: { 'Authorization': userToken }
                          }).then((response) => {
                            if (response.data.noAuth) {
                              cookies.remove('tokenCTF', { path: '/' });
                              history.push('/login');
                            }
                            else {
                              setChallengeIdEdit(item.challenge_id)
                              setNameEdit(response.data[0].name)
                              setDescriptionEdit(response.data[0].description)
                              setLinkEdit(response.data[0].link)
                              setValueEdit(response.data[0].value)
                              setCategoryEdit(response.data[0].category_id)
                              setFlagEdit(response.data[0].flag)
                              setModalAdChallEdit(true);
                            }
                          })
                          }>
                            <Edit fontSize="small" color="primary" />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => { handleOpenRemoveDialog(item.challenge_id) }}>
                            <Cancel fontSize="small" />
                          </IconButton>

                        </div>
                      </TableCell>


                    </TableRow>
                  ))
                }

              </TableBody>
            </TblContainer>
            <TblPagination />
          </Paper>
        </div>
        <div className="pageContentTableAdmin2">
          <Paper className="paperContentTable">
            <div align="right">
              <Button variant="outlined" color="primary" onClick={() => openModalHint()}  >Nueva pista</Button>
            </div>
            <TblContainerHint>
              <TblHeadHint className="cell" />
              <TableBody>
                {
                  recordsAfterPagingAndSortingHint().map((item) => (

                    <TableRow key={item.hint_id} >
                      <TableCell > {item.name}</TableCell>
                      <TableCell >{item.hint}</TableCell>
                      <TableCell >{item.cost}</TableCell>
                      <TableCell>
                        <div className="actions-admin">
                          <IconButton onClick={() => axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challengesAdmin/getHintID/${item.hint_id}`, {
                            headers: { 'Authorization': userToken }
                          }).then((response) => {
                            if (response.data.noAuth) {
                              cookies.remove('tokenCTF', { path: '/' });
                              history.push('/login');
                            }
                            else {
                              setHintIDEdit(item.hint_id)
                              setHintEdit(response.data[0].hint)
                              setCostEdit(response.data[0].cost)
                              setModalAdHintEdit(true);
                            }
                          })
                          }>
                            <Edit fontSize="small" color="primary" />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => { handleOpenRemoveDialogHint(item.hint_id) }}>
                            <Cancel fontSize="small" />
                          </IconButton>

                        </div>
                      </TableCell>


                    </TableRow>
                  ))
                }

              </TableBody>
            </TblContainerHint>
            <TblPaginationHint />
          </Paper>
        </div>
        <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" className="alertWidthTop">
            {error}
          </Alert>
        </Snackbar>
        <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" className="alertWidthTop">
            {success}
          </Alert>
        </Snackbar>
        <Dialog
          open={openRemoveDialog}
          onClose={handleCloseRemoveDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Eliminar Reto"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea eliminar el reto?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={(e) => { deleteChallenge(removeChallengeID) }}>Sí</Button>
            <Button onClick={handleCloseRemoveDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openRemoveDialogHint}
          onClose={handleCloseRemoveDialogHint}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Eliminar Reto"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea eliminar la pista?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={(e) => { deleteHint(removeHintID) }}>Sí</Button>
            <Button onClick={handleCloseRemoveDialogHint} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>

    </>

  );

};

export default ChallengesAdmin;